import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MileCalculatorService } from '../shared/services/mile-calc.service';
import { DestinationTypeEnum } from '../shared/enums/destination.enum';
import { FormControlNameEnum } from '../shared/enums/form-control.enum';
import { GetDistanceBetweenLocationsPath, GetDistanceBetweenLocationsQuery } from '@xpo-ltl-2.0/sdk-infrastructure';
import { CountryCd, MileRouteTypeCd } from '@xpo-ltl/sdk-common';
import { RouteTypeEmum } from '../shared/enums/route-type.enum';
import { SelectObject } from '../shared/model/select.model';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent {
  originForm: FormGroup;
  destinationForm: FormGroup;
  routeForm: FormGroup;

  displayZipOnly: boolean;
  displayStateCity: boolean;

  miles: number;

  routeTypes: SelectObject<MileRouteTypeCd>[] = [];

  constructor(private mileCalculatorService: MileCalculatorService) {
    this.buildForms();

    this.routeTypes.push(new SelectObject<MileRouteTypeCd>('Practical Route', MileRouteTypeCd.PRACTICAL_ROUTE));
    this.routeTypes.push(new SelectObject<MileRouteTypeCd>('HHG Route', MileRouteTypeCd.HOUSEHOLD_HHG_ROUTE));
    this.routeTypes.push(new SelectObject<MileRouteTypeCd>('Dock To Dock Route', MileRouteTypeCd.DOCK_TO_DOCK_ROUTE));
  }

  private buildForms(): void {
    this.originForm = new FormGroup({
      countryCd: new FormControl(CountryCd.UNITED_STATES, [Validators.required]),
      inputMethod: new FormControl('', [Validators.required]),
      zipCd: new FormControl('', [Validators.required]),
    });

    this.destinationForm = new FormGroup({
      countryCd: new FormControl(CountryCd.UNITED_STATES, [Validators.required]),
      inputMethod: new FormControl('', [Validators.required]),
      zipCd: new FormControl('', [Validators.required]),
    });

    this.routeForm = new FormGroup({
      routeType: new FormControl(MileRouteTypeCd.HOUSEHOLD_HHG_ROUTE, [Validators.required]),
    });

    this.destinationForm.get(FormControlNameEnum.INPUT_METHOD).disable();

    this.originForm.get(FormControlNameEnum.INPUT_METHOD).valueChanges.subscribe((type) => {
      this.miles = -1;
      this.handleDestinationType(type);
    });

    this.routeForm.get(FormControlNameEnum.ROUTE_TYPE).valueChanges.subscribe((type) => {
      this.miles = -1;
    });

    this.destinationForm.get(FormControlNameEnum.ZIP_CD).valueChanges.subscribe(() => {
      this.miles = -1;
    });
    this.originForm.get(FormControlNameEnum.ZIP_CD).valueChanges.subscribe(() => {
      this.miles = -1;
    });
  }

  private handleDestinationType(type: DestinationTypeEnum): void {
    this.destinationForm.get(FormControlNameEnum.INPUT_METHOD).patchValue(type);
    this.displayZipOnly = false;
    this.displayStateCity = false;

    switch (type) {
      case DestinationTypeEnum.ZIP_ONLY:
        this.displayZipOnly = true;
        break;
      case DestinationTypeEnum.STATE_CITY:
        this.displayStateCity = true;
        this.originForm.get(FormControlNameEnum.ZIP_CD).patchValue('');
        this.destinationForm.get(FormControlNameEnum.ZIP_CD).patchValue('');
        break;
    }
  }

  calculateDistance(): void {
    const path = new GetDistanceBetweenLocationsPath();
    path.origin = this.originForm.get(FormControlNameEnum.ZIP_CD).value;
    path.destination = this.destinationForm.get(FormControlNameEnum.ZIP_CD).value;

    const queryParams = new GetDistanceBetweenLocationsQuery();
    queryParams.routeTypeCd = this.routeForm.get(FormControlNameEnum.ROUTE_TYPE).value;

    this.mileCalculatorService.getDistanceBetweenLocations(path, queryParams).subscribe({
      next: (miles) => {
        this.miles = miles;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  clear(): void {
    this.miles = -1;
    this.originForm.reset();
    this.destinationForm.reset();
    this.originForm.get(FormControlNameEnum.COUNTRY_CD).patchValue(CountryCd.UNITED_STATES);
    this.destinationForm.get(FormControlNameEnum.COUNTRY_CD).patchValue(CountryCd.UNITED_STATES);
    this.routeForm.get(FormControlNameEnum.ROUTE_TYPE).patchValue(RouteTypeEmum.HHG_ROUTE);
  }
}
